import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';

import Repeater from '@Utils/Repeater';
import { ArmyListUnit, ArmyListUnitOption } from '@Models';
import { ArmyListUnitExportView } from '@Selectors/builder/myArmyList/export/view/export';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import { displayExportTxtOldWorld } from '@Selectors/builder/myArmyList/export/displayExportTxtOldWorld';

export interface IArmyListExportOldWorldProps {
  markdown: boolean;
}

const ArmyListExportOldWorld: React.FC<ArmyListExportWithRateProps> = (
  {
    markdown,
    name,
    game,
    army,
    points,
    armyListUnits,
    exportTxt,
  }
) => {
  const copied = () => toast.success('Copied!');

  return (
    <section className="col-12 col-md-10 offset-md-1">
      <div>
        <p>{markdown && (<>## </>) || (<>===<br /></>)}{name || army} [{points} pts]<br />
          {game}, {army}{!markdown && (<><br />===</>)}</p>
      </div>
      <Repeater data={armyListUnits} indexPrefix="unit">
        {
          (item: ArmyListUnitExportView) =>
            <div>
              {markdown && (
                <p className="mt-3">### {item.name}</p>
              ) || (
                <p className="mt-3">++ {item.name} ++</p>
              )}
              <Repeater data={item.armyListUnits} indexPrefix="unit">
                {
                  (unit: ArmyListUnit) => (
                    <div className="mt-3">
                      {markdown && (
                        <p>- {unit.size > 1 && (<>{unit.size} </>)}{unit.unitName} [{unit.points} pts]<br />
                          &nbsp;-# ({unit.army_list_unit_unit_options.map(o => o.name).join(', ')}) </p>
                      ) || (
                        <p>{unit.size > 1 && (<>{unit.size} </>)}{unit.unitName} [{unit.points} pts]<br />
                          <Repeater data={unit.army_list_unit_unit_options} indexPrefix="unit-option">
                            {
                              (option: ArmyListUnitOption) => (
                                <>- {option.name}{option.quantity > 1 && (<> x{option.quantity}</>)}<br /></>
                              )
                            }
                          </Repeater></p>
                      )}
                    </div>
                  )
                }
              </Repeater>
            </div>
        }
      </Repeater>
      <footer className="mt-3">
        {markdown && (<>*</>) || (<>---<br /></>)}Créé avec "9Th Builder"{markdown && (<>* </>) || (<>
        <br />[</>)}https://www.9thbuilder.com{!markdown && (<>]</>)}
      </footer>
      <div className="text-center">
        <CopyToClipboard text={exportTxt} onCopy={() => copied()}>
          <button className="btn btn-age"><i className="fa fa-2x actions fa-copy" /> Copy to clipboard</button>
        </CopyToClipboard>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListExportOldWorldProps) =>
  displayExportTxtOldWorld(state, owsProps);

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListExportOldWorld);

type ArmyListExportWithRateProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  IArmyListExportOldWorldProps
